import developmentConfig from "./config.development";
import productionConfig from "./config.production";

const env = process.env.NODE_ENV || "development";

const config =
  {
    development: developmentConfig,
    production: productionConfig,
    test: developmentConfig,
  }[env.trim()] || developmentConfig;

export default config;
